import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from "react-router";
import { ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import { ToxnotSignInRequiredComponent } from "../core/BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { ApplicationState } from "../../store";
import { TeamRole } from '../../store/Models/UserContext';
import Layout from "../Layout";


interface RouteParams {
    key: string;
}

interface RegulationDetailLibraryProps extends RouteComponentProps<RouteParams>, ToxnotComponentProperties {
    appServices: any;
}


class RegulationDetailLibrary extends ToxnotSignInRequiredComponent<RegulationDetailLibraryProps> {
    constructor(props: RegulationDetailLibraryProps) {
        super(props);
    }

    protected getDisallowedRoles(): TeamRole[] {
        return []; 
    }

    protected renderConcreteComponent(): JSX.Element | null {

        const userContext = this.getUserContext();

        if (!userContext?.userCapabilities.regulationsEnabled) {
            return (
                <Layout>
                    <div className="tn-section text-center">
                        <p>{this.localizeString("You don't have access to view Regulation pages")}</p>
                    </div>
                </Layout>
            );
        }

        const config = this.props.appServices.config;
        if (!config) {
            console.error('Config is not defined');
            return <div>Config is not available</div>;
        }

        const extractKeyFromPath = (pathname: string): string => {
            const match = pathname.match(/\/([^\/]+)$/);
            return match ? match[1] : "";
        };

        const key = extractKeyFromPath(this.props.location.pathname);
        return (
            <Layout>
                <pfas-regulation-details
                    id="regulationDetailsMfe"
                    bff-base-url={config.regulationBffBaseUrl}
                    mfe-base-url={`${config.regulationDetailsBaseUrl}`}
                    regulation-library-url={`${config.toxnotWebAppUrlEndpoint}/regulations`}
                    regulation-document-key={key}
                    locale={`${this.props.appServices.userContext.cultureName}`}
                ></pfas-regulation-details>
            </Layout>
        );
    }
}

export default connect(
    (state: ApplicationState) => ({ appServices: state.appServices })
)(withRouter(RegulationDetailLibrary) as any);
